module.exports = __webpack_public_path__ + "static/media/installMainImg.741ad611.jpeg";